import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface LidLabelOption {
  key: string;
  value: string;
}

export const getLidLabelsAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.LOSS_AND_DAMAGE}/GetLidLabel`,
  });
};

export type LidLabelsResponse = LidLabelOption[];

export const fetchLidLabels = async (): Promise<LidLabelsResponse> => {
  const response: AxiosResponse<LidLabelsResponse> = await getLidLabelsAPI();
  return response.data;
};
